import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function AdminProfile() {
  const { user, setUser } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [email, setEmail] = useState(user?.email || "");
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");

  const saveProfile = async () => {
    try {
      const { data } = await api.put("/auth/profile", { name, email });
      setUser({ id: data.id, email: data.email, name: data.name });
      toast.success("Profile updated.");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Save failed");
    }
  };
  const changePw = async () => {
    if (!cur || !next) return toast.error("Fill both fields");
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: next });
      setCur(""); setNext("");
      toast.success("Password changed.");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Change failed");
    }
  };

  return (
    <div className="space-y-6 max-w-2xl">
      <div>
        <div className="text-xs uppercase tracking-[0.24em] text-amber-600">Account</div>
        <h1 className="font-display text-3xl text-slate-950 mt-1">Profile</h1>
      </div>
      <Card className="border border-slate-200"><CardContent className="p-6 space-y-4">
        <div><Label>Name</Label><Input value={name} onChange={(e) => setName(e.target.value)} data-testid="profile-name" /></div>
        <div><Label>Email</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="profile-email" /></div>
        <div><Button onClick={saveProfile} className="bg-slate-950 hover:bg-slate-800" data-testid="profile-save-btn">Save profile</Button></div>
      </CardContent></Card>
      <Card className="border border-slate-200"><CardContent className="p-6 space-y-4">
        <div className="text-sm font-medium text-slate-700">Change password</div>
        <div><Label>Current password</Label><Input type="password" value={cur} onChange={(e) => setCur(e.target.value)} data-testid="pw-cur" /></div>
        <div><Label>New password</Label><Input type="password" value={next} onChange={(e) => setNext(e.target.value)} data-testid="pw-new" /></div>
        <div><Button onClick={changePw} className="bg-slate-950 hover:bg-slate-800" data-testid="pw-save-btn">Change password</Button></div>
      </CardContent></Card>
    </div>
  );
}
